import React, { useEffect, useState } from "react";

import { Alert } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { CategoryCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult } from "@/types";
import { filterItems } from "@/utils";

interface CausesViewProps {
  scores: InsightResult[];
}

export const CausesView: React.FC<CausesViewProps> = ({ scores }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [causes, setCauses] = useState<InsightResult[]>([]);

  const maxScore = Math.max.apply(
    Math,
    scores
      .filter((x) => x.tag_name !== x.tag_category)
      .map((x) => Number(x[scoreType.value as keyof InsightResult])),
  );
  const minScore =
    scoreType.value === "rate"
      ? Math.min.apply(
          Math,
          scores
            .filter((x) => x.tag_name !== x.tag_category)
            .map((x) => Number(x[scoreType.value as keyof InsightResult])),
        )
      : Math.max(1 - (maxScore - 1), 0);

  useEffect(() => {
    setCauses(filterItems(scores, scoreType.value));
  }, [scores, scoreType]);

  return (
    <>
      <Grid container size={12} spacing={2}>
        {scores.length === 0 && (
          <Grid>
            <Alert variant="filled" severity="info">
              No Cause Insights data found for this audience. Please re-build
              the audience in order to enable Cause Insights
            </Alert>
          </Grid>
        )}

        {/* Cause View */}
        {causes.map((interest, index) => (
          <CategoryCard
            key={`spend-category-${index}`}
            category={interest.tag_name}
            value={Number(interest[scoreType.value as keyof InsightResult])}
            score={scoreType.value}
            type="cause"
            minValue={minScore}
            maxValue={maxScore}
          />
        ))}
      </Grid>
    </>
  );
};

export default CausesView;
